import { useImageConfigStore } from "@/stores/image-config-store";
import { AppProviders } from "./providers";
import { AppRouter } from "./routes";

// Initialize image config store on app load
useImageConfigStore.getState().loadConfig();

export default function App() {
  return (
    <AppProviders>
      <AppRouter />
    </AppProviders>
  );
}
